import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Components/Header";
import HeroSection from "./Hero";
import ForWhom from "./Benefits";
import Business from "./SixSection";
import Footer from "../Components/Footer";
import CTASection from "../AboutUs/CtaSection";
import Fast from "./FastandFlexible";

function TennetHome() {
  const location = useLocation();
  const businessRef = useRef(null);
  const forWhomRef = useRef(null);

  // Scroll ke bagian yang ditentukan setelah komponen dimuat
  useEffect(() => {
    if (location.state && location.state.section) {
      const { section } = location.state;
      const ref = section === "business" ? businessRef : forWhomRef;
      ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location.state]);

  return (
    <div>
      <Header businessRef={businessRef} forWhomRef={forWhomRef} />
      <main>
        <HeroSection />
        <section id="business" ref={businessRef}>
        <Business />
        {/* Content for business section */}
      </section>
      <section id="forWhom" ref={forWhomRef}>
      <ForWhom />
      </section>
        <Fast />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default TennetHome;
